import { Component, HostBinding, Input } from '@angular/core';
import { BaseDirective } from '../../../base.directive';

@Component({
    selector: 'eui-icon-colored, span[euiIconColored], [euiIconColored]',
    template: `
    <span [class]="iconClass">
        <span *ngFor="let pathNumber of paths" class="path{{pathNumber}}"></span>
    </span>
    `,
})
export class EuiIconColorComponent extends BaseDirective {
    public paths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

    @HostBinding('class')
    public get cssClasses(): any {
        return this.getCssClasses();
    }

    @Input() iconClass;

    constructor() {
        super();
    }

    getCssClasses() {
        return [
            super.getCssClasses('eui-icon eui-icon-color'),
            this.iconClass ? this.iconClass : ``,
        ].join(' ').trim();
    }
}
